import { useAuthStore } from "@/stores/authStore";

export const Logo = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // Un rechargement complet garantit la remise a zero de la page courante.
  const handleLogoClick = () => {
    const destination = isAuthenticated ? "/" : "/login";
    window.location.assign(destination);
  };

  return (
    <button
      type="button"
      className="flex items-center gap-2 cursor-pointer"
      onClick={handleLogoClick}
      aria-label="Retour a l'accueil"
    >
      <img
        src="/assets/logo.png"
        alt="PIXAtwin Logo"
        className="h-10 w-10 hover:opacity-80 transition-opacity"
      />
      <img
        src="/assets/pixatwin_text.png"
        alt="PIXAtwin Text"
        className="h-8 hover:opacity-80 transition-opacity"
      />
    </button>
  );
};
